const BUTTON_TYPE = {
  SOCIAL: "social",
  WALLET: "wallet"
};

export { BUTTON_TYPE };
